import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatPhoneNumber',
    standalone: false
})
export class FormatPhoneNumberPipe implements PipeTransform {

transform(value: string | number): string {
    if (!value) return '';    
    let phone = value.toString().replaceAll(/\D/g, '');

    if (phone.length === 9) {
      phone = phone.slice(1);
    }

    return `+569 ${phone}`;
  }

}
